import axios from "axios";
import $ from 'jquery';
import { isChrome as chrome,isMobile as mobileTab,isMobileOnly as omobile,isTablet as tablete,isBrowser as browser,isSmartTV as smarttv,isWearable as wearable,isAndroid as android,isWinPhone as winphone,isIOS as ios,isFirefox as ff,isSafari as safari,isOpera as opera,isIE as ie,isEdge as edge,isYandex as yandex,isChromium as chromium,isMobileSafari as mobsafari,osVersion as version,osName as osname,fullBrowserVersion as fbrowserversion,browserVersion as browserVer,browserName as browserName,mobileVendor as mobvendor,mobileModel as mobmodel,engineName as engName,engineVersion as engversion,getUA as getua,deviceType as deviceType,isIOS13 as ios13,isIPhone13 as iphone13,isIPad13 as ipad13,isIPod13 as ipod13,isElectron as isElectron,deviceDetect as devicedetect} from "react-device-detect";
const productSaveProductList = function(mod)
{ 
		if ( mod )
			{
				console.log('MATCH');
				
				if(this.state.shoppingProductName){
				 const saveProduct = {
					 name:this.state.shoppingProductName,
					 productName:this.state.addProduct[0].name,
					 attributes:this.state.productInformation,
					 channelId: localStorage.getItem("channelId"),
					 groupId:localStorage.getItem("groupId"),
					 image:this.state.imageName,
					 id: this.state.chosenProductId
				 }
				 $('.main_loader').attr({'style':'display:flex'});
				 let token = JSON.parse(localStorage.getItem('userData')).data.responseData.token;
				 axios.defaults.headers.common['Authorization'] = token;
				 axios.post(process.env.REACT_APP_NAME+"/api/v1/session/editProduct", {saveProduct})
				 .then(res => {
				
				   //console.log(res);
				   if(res.data.responseMessage == "success")
				   {
					for(let k in this.state.productInformation){
						let attributeValue =this.state.productInformation[k].attrValue='';
						this.state.attrValue= attributeValue;
						console.log("LOOP INFOMNNAANAAN>>>>",this.state.productInformation[k].attrValue);
					}
					this.setState({
						addProduct:[],
						productInformation:[],
						imageName: false,
						responseMessage:""+res.data.responseData+"  has been updated.",
						shoppingProductName:'',
						imagePreviewUrl:"/images/browse-image.png"?"/images/browse-image.png":'',
						// addProduct:[],
						// imagePreviewUrl:"/images/browse-image.png",
						// productInformation:[]
					},()=>{
						console.log("===========",this.state.imageName)
						//this.fetchAttributesList();
						
						this.fetchAttributesList();
						this.getProducts(true);
						$("#editProdSuccess_popup").attr({'style':'display:block'});
						// $("#invitation_popup").attr({'style':'display:block'});
						$("#product_lst_modal").attr({'style':'display:none'});
					})
				   
					}else{
					 console.log('=============There Is an Error===================>'); 
				   }
				 }).catch(err => {
					 console.log(this.state.productInformation.length)
				//	 if(this.state.productInformation.length===0){
					this.setState({
						//responseMessage:"Please Select atleast one of attribute",
						shoppingProductName:'',
						addProduct:[],
						imageName: false,
						imagePreviewUrl:"/images/browse-image.png",
						productInformation:[]
					},()=>{
						
						this.fetchAttributesList();
						//$("#invitation_popup").attr({'style':'display:block'});  
						})
				//	}
				  });
				  
				} else{
					this.setState({
						//responseMessage:"Product name can't be blank",
						shoppingProductName:'',
						addProduct:[],
						imageName: false,
						imagePreviewUrl:"/images/browse-image.png",
						productInformation:[]
					},()=>{
						//console.log("===========",this.state.imageName)
						this.fetchAttributesList();
						//$("#invitation_popup").attr({'style':'display:block'});  
						})
				}
				
				
				return;
			}
		 if(this.state.shoppingProductName){
		 const saveProduct = {
			 name:this.state.shoppingProductName,
			 productName:this.state.addProduct[0].name,
			 attributes:this.state.productInformation,
			 channelId: localStorage.getItem("channelId"),
			 groupId:localStorage.getItem("groupId"),
			 image:this.state.imageName
		 }
		 let token = JSON.parse(localStorage.getItem('userData')).data.responseData.token;
		 axios.defaults.headers.common['Authorization'] = token;
		 axios.post(process.env.REACT_APP_NAME+"/api/v1/session/addProduct", {saveProduct})
		 .then(res => {
	 
		   //console.log(res);
		   if(res.data.responseMessage == "success")
		   {
			for(let k in this.state.productInformation){
				let attributeValue =this.state.productInformation[k].attrValue='';
				this.state.attrValue= attributeValue;
				console.log("LOOP INFOMNNAANAAN>>>>",this.state.productInformation[k].attrValue);
			}
			this.setState({
				responseMessage:""+res.data.responseData+"  has been added to your channel product list.",
				shoppingProductName:'',
				imageName: false,
				imagePreviewUrl:"/images/browse-image.png"?"/images/browse-image.png":'',
				// addProduct:[],
				// imagePreviewUrl:"/images/browse-image.png",
				// productInformation:[]
			},()=>{
				console.log("===========",this.state.imageName)
				//this.fetchAttributesList();
				$("#addProdSuccess_popup").attr({'style':'display:block'});
				// $("#invitation_popup").attr({'style':'display:block'});
				$("#product_lst_modal").attr({'style':'display:none'});
			})
		   
			}else{
			 console.log('=============There Is an Error===================>'); 
		   }
		 }).catch(err => {
			 console.log(this.state.productInformation.length)
		//	 if(this.state.productInformation.length===0){
			this.setState({
				//responseMessage:"Please Select atleast one of attribute",
				shoppingProductName:'',
				addProduct:[],
				imageName: false,
				imagePreviewUrl:"/images/browse-image.png",
				productInformation:[]
			},()=>{
				
				this.fetchAttributesList();
				//$("#invitation_popup").attr({'style':'display:block'});  
				})
		//	}
		  });
		  
		} else{
			this.setState({
				//responseMessage:"Product name can't be blank",
				shoppingProductName:'',
				addProduct:[],
				imagePreviewUrl:"/images/browse-image.png",
				productInformation:[],
				imageName: false
			},()=>{
				//console.log("===========",this.state.imageName)
				this.fetchAttributesList();
				//$("#invitation_popup").attr({'style':'display:block'});  
				})
		}
}

export { productSaveProductList };